$('.cards-container-testimonials').slick({
  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 1,
  variableWidth: true,
  dots: true,
  autoplay: true,

  prevArrow: `
    <div class="left-arrow">
      <img src="//theideaspace.io/cdn/shop/t/41/assets/right-arrow.png?v=76568320805242524811767474547" alt="Previous">
    </div>
  `,

  nextArrow: `
    <div class="right-arrow">
      <img src="//theideaspace.io/cdn/shop/t/41/assets/right-arrow.png?v=76568320805242524811767474547" alt="Next">
    </div>
  `,

  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '25px', // Reduce side gap on mobile
        variableWidth: true,
        arrows: false,
      }
    }
  ]
});